<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="fm_head" id="map"><a href="#/text/9780062982735_Contents#rmap">Map</a></p>
<p class="full"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><img alt="image" src="images/fviii-01.jpg"/></span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062982735_Map.vue?438485c8